import React from "react";
import DropDown from "get-life-storybook-ts/lib/components/Inputs/Input_DropDown/DropDown";
import Input from "get-life-storybook-ts/lib/atoms/Input/Input";
import SingleSelect from "get-life-storybook-ts/lib/components/Inputs/Input_Select/SingleSelect/SingleSelect";
import Typography from "get-life-storybook-ts/lib/atoms/Typography/Typography";
import CheckboxAtom from "get-life-storybook-ts/lib/atoms/Checkbox/Checkbox";
import BirthDateInput from "get-life-storybook-ts/lib/organisms/BirthDateInput/BirthDateInput";
import ButtonDS from "get-life-storybook-ts/lib/atoms/ButtonDS/ButtonDS";

import CalculatorModuleITController, {
  StrapiDataCalculator,
} from "./CalculatorModuleIT.controller";

interface OverlayI {
  isMobile?: boolean;
}

const CalculatorModuleIT: React.FC<StrapiDataCalculator> = ({ data }) => {
  const {
    actualStep,
    capitalOptions,
    display,
    formDataFirst,
    formDataSecond,
    formError,
    handleBlur,
    handleButton,
    handleChange,
    handleFocus,
    loading,
    optionsSmokeInsurance,
    optionsGenderInsurance,
    setActualStep,
    setDisplay,
    setFormDataFirst,
    setFormDataSecond,
    optionalCheck,
    setOptionalCheck,
    trackStepBack,
  } = CalculatorModuleITController({ data });

  const checkBoxQuery = (
    <>
      <div className="flex flex-col">
        <Typography
          variant="BodyMedium"
          text="Acconsento al trattamento dei dati personali avendo preso visione dell’"
          color="ligth-gray"
        />
         <Typography
          variant="LinkMedium"
          text="Informativa sulla Privacy"
          color="ligth-gray"
          target="_blank"
          href="https://life5.it/informativa-privacy/"
        />
      </div>
    </>
  );

  const checkBoxQuery2 = (
    <>
      <div className="flex flex-col">
        <Typography
          variant="BodyMedium"
          text="Accetto il trattamento dei miei dati per le comunicazioni promozionali"
          color="ligth-gray"
        />
      </div>
    </>
  );

  const checkBoxQuery3 = (
    <>
      <div className="flex flex-col">
        <Typography
          variant="BodyMedium"
          text="Confermo che l’e-mail e il telefono forniti sono quelli del titolare della polizza."
          color="ligth-gray"
        />
      </div>
    </>
  );

  const checkBoxQuery4 = (
    <>
      <div className="flex flex-col">
        <Typography
          variant="BodyMedium"
          text="Confermo di essere a conoscenza che informazioni inesatte o incomplete potrebbero limitare e/o escludere il diritto alla prestazione assicurativa, in linea con quanto riportato nel set informativo e nelle condizioni di assicurazione"
          color="ligth-gray"
        />
      </div>
    </>
  );

  return (
    <>
      <div
        className={`w-full md:max-w-[450px] ${
          actualStep === 1 && display ? "min-h-[562px]" : "min-h-[528px]"
        } flex flex-col pt-6 px-4 pb-8 gap-8 rounded-lg shadow-lg`}
        style={{
          backgroundColor:
            (data && data[0] && data[0].backgroundColor) ?? "#F5F7FA",
        }}
      >
        <div className="flex flex-col justify-center items-center gap-6">
          <div className="flex flex-row gap-4 w-full">
            <Typography
              variant="BodySmall"
              text="Passo 1"
              color={actualStep === 1 ? "purple" : "ligth-gray"}
              onClick={() => {
                if (actualStep > 1) {
                  trackStepBack(actualStep, 1);
                  setActualStep(1);
                }
              }}
              className="cursor-pointer"
            />
            <Typography variant="BodySmall" text=">" color="ligth-gray" />
            <Typography
              variant="BodySmall"
              text="Passo 2"
              color={actualStep === 2 ? "purple" : "ligth-gray"}
              className={`${
                actualStep === 1 ? "cursor-pointer" : "cursor-not-allowed"
              }`}
              onClick={() => {
                if (actualStep === 1) {
                  setActualStep(2);
                }
              }}
            />
            <Typography variant="BodySmall" text=">" color="ligth-gray" />
            <Typography
              variant="BodySmall"
              text="Il tuo preventivo"
              color="ligth-gray"
            />
          </div>
          {actualStep === 1 && (
            <>
              {!display && (
                <>
                  <BirthDateInput
                    label="Quando sei nato?                    "
                    initialValue={formDataFirst.birthDate}
                    handleFocus={handleFocus}
                    setter={(birthDate: string) =>
                      setFormDataFirst({
                        ...formDataFirst,
                        birthDate,
                      })
                    }
                    birthDateError={formError?.birthDate}
                    placeholderDay="Giorno"
                    placeholderMonth="Mese"
                    placeholderYear="Anno"  
                  />
                  <div className="flex flex-col w-full">
                    <Typography
                      variant="Body"
                      text="Sei"
                      color="gray-text"
                    />
                    <div className="flex flex-col gap-4">
                      <SingleSelect
                        name="gender_select"
                        initialValue={formDataFirst.gender}
                        onValueChange={(e: any) =>
                          handleChange({
                            setValue: setFormDataFirst,
                            value: e,
                            field: "gender",
                            formData: formDataFirst,
                          })
                        }
                        options={optionsGenderInsurance}
                        defaultVariant="Standard"
                        defaultSize="S"
                      />
                      {formError?.gender?.message && (
                        <Typography
                          text={formError?.gender?.message}
                          variant="BodySmall"
                          weight="400"
                          className="text-red"
                        />
                      )}
                    </div>
                  </div>
                  <div className="flex flex-col w-full">
                    <Typography
                      variant="Body"
                      text="Fumi?"
                      color="gray-text"
                    />
                    <div className="flex flex-col gap-4">
                      <SingleSelect
                        name="smoke_select"
                        initialValue={formDataFirst.smoke}
                        onValueChange={(e: any) =>
                          handleChange({
                            setValue: setFormDataFirst,
                            value: e,
                            field: "smoke",
                            formData: formDataFirst,
                          })
                        }
                        options={optionsSmokeInsurance}
                        defaultVariant="Standard"
                        defaultSize="S"
                      />
                      {formError?.smoke?.message && (
                        <Typography
                          text={formError?.smoke?.message}
                          variant="BodySmall"
                          weight="400"
                          className="text-red"
                        />
                      )}
                    </div>
                  </div>
                </>
              )}
              <div className="flex flex-col w-full">
                <Typography
                  variant="Body"
                  text="Capitale assicurato"
                  color="gray-text"
                />
                <div className="flex flex-col gap-4">
                  <DropDown
                    isSimple
                    bgWhite
                    initialValue={(formDataFirst.capital || "") as string}
                    handleDisplay={(displayItem: boolean) =>
                      setDisplay(displayItem)
                    }
                    onValueChange={(e: any) =>
                      handleChange({
                        setValue: setFormDataFirst,
                        value: e,
                        field: "capital",
                        formData: formDataFirst,
                      })
                    }
                    options={capitalOptions}
                    disabled={capitalOptions.length === 0}
                    className="w-full"
                    placeholder="Scegli un’opzione"
                    initialError={formError?.capital}
                  />
                </div>
              </div>
            </>
          )}

          {actualStep === 2 && (
            <>
              <div className="flex flex-col w-full">
                <Typography variant="Body" text="Email" color="gray-text" />
                <div className="flex flex-row gap-4">
                  <Input
                    initialValue={formDataSecond.email}
                    inputMode="email"
                    autoComplete="email"
                    autoFocus
                    onBlur={() =>
                      handleBlur({ field: "email", formData: formDataSecond })
                    }
                    onValueChange={(e: any) =>
                      handleChange({
                        setValue: setFormDataSecond,
                        value: e,
                        field: "email",
                        formData: formDataSecond,
                      })
                    }
                    placeholder="Scrivi il tuo indirizzo mail"
                    initialError={formError?.email}
                    id="emailInput"
                  />
                </div>
              </div>
              <div className="flex flex-col w-full">
                <Typography variant="Body" text="Telefono" color="gray-text" />
                <div className="flex flex-row gap-4">
                  <Input
                    initialValue={formDataSecond.phone}
                    inputMode="number"
                    autoComplete="phone"
                    pattern="\d*"
                    onBlur={() =>
                      handleBlur({ field: "phone", formData: formDataSecond })
                    }
                    onValueChange={(e: any) =>
                      handleChange({
                        setValue: setFormDataSecond,
                        value: e,
                        field: "phone",
                        formData: formDataSecond,
                      })
                    }
                    placeholder="Scrivi il tuo numero di telefono"
                    initialError={formError?.phone}
                    id="phoneInput"
                  />
                </div>
              </div>
              <div className="flex flex-col w-full">
                <CheckboxAtom
                  label={checkBoxQuery}
                  onValueChange={(checkedConditions: boolean) =>
                    handleChange({
                      setValue: setFormDataSecond,
                      value: checkedConditions,
                      field: "checkedConditions",
                      formData: formDataSecond,
                    })
                  }
                  isLegal
                  errorCheck={formError?.checkedConditions}
                  className="!p-0"
                />
              </div>
              <div className="flex flex-col w-full">
                <CheckboxAtom
                  label={checkBoxQuery2}
                  checked={optionalCheck}
                  onValueChange={() =>
                    setOptionalCheck(!optionalCheck)
                  }
                  isLegal
                  className="!p-0"
                />
              </div>
              <div className="flex flex-col w-full">
                <CheckboxAtom
                  label={checkBoxQuery3}
                  onValueChange={(checkedConditions3: boolean) =>
                    handleChange({
                      setValue: setFormDataSecond,
                      value: checkedConditions3,
                      field: "checkedConditions3",
                      formData: formDataSecond,
                    })
                  }
                  isLegal
                  errorCheck={formError?.checkedConditions3}
                  className="!p-0"
                />
              </div>
              <div className="flex flex-col w-full">
                <CheckboxAtom
                  label={checkBoxQuery4}
                  onValueChange={(checkedConditions4: boolean) =>
                    handleChange({
                      setValue: setFormDataSecond,
                      value: checkedConditions4,
                      field: "checkedConditions4",
                      formData: formDataSecond,
                    })
                  }
                  isLegal
                  errorCheck={formError?.checkedConditions4}
                  className="!p-0"
                />
              </div>
            </>
          )}

          <div className="flex flex-col w-full">
            <ButtonDS
              label={actualStep === 1 ? "Continua" : "Preventivo"}
              onClick={() => handleButton()}
              disabled={loading}
              rightIcon="ArrowRightIcon"
              className="w-full"
            />
            {formError?.submission?.message && (
              <Typography
                text={formError.submission.message}
                variant="BodySmall"
                weight="400"
                className="text-red mt-2"
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CalculatorModuleIT;
